import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHeadline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"headline, heading"} maskId="square-filled-radius-0-stroke-1-IconHeadline"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H8V4H6V11.5H18V4H16V3H21V4H19V20H21V21H16V20H18V12.5H6V20H8V21H3V20H5V4H3V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHeadline;
